/**
 * InventoryModeBanner — sticky banner shown above the inventory when an
 * Inventory Mode is active. Renders the mode's `banner({ context })`
 * copy + a Cancel button.
 *
 * Modes are defined in `contexts/inventoryModes.js`. The parent passes
 * the resolved mode + context from useInventoryMode().
 *
 * Reuses the .dup-hash-banner CSS shape — same role (transient,
 * dismissible, sits above the toolbar).
 */
export default function InventoryModeBanner({ mode, context, onCancel }) {
  if (!mode || !context) return null;
  const copy = typeof mode.banner === 'function' ? mode.banner({ context }) : '';
  return (
    <div className="inv-mode-banner" role="status" aria-live="polite">
      <span className="inv-mode-banner__body">
        {mode.icon && <span className="inv-mode-banner__icon">{mode.icon}</span>}
        <strong>{mode.label}:</strong>
        <span className="inv-mode-banner__copy">{copy}</span>
      </span>
      <button
        type="button"
        className="btn btn-sm inv-mode-banner__cancel"
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  );
}
